import { ReactNode, useMemo } from 'react';
import { HtmlContent } from './Cms';
import DiagramMotion from './DiagramMotion';
export default function CmsServiceArticle({ html, introduction, visual }: { html: string; introduction?: ReactNode; visual?: ReactNode }) {
  const article = useMemo(() => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const editorial = Boolean(doc.querySelector('.service-editorial'));
    Array.from(doc.querySelectorAll('h2')).forEach((heading, i) => {
      heading.id = `article-section-${i + 1}`;
    });
    // Presentation labels from the earlier layout are not article content.
    doc.querySelectorAll('.eyebrow').forEach(label => {
      const text = label.textContent?.trim() || '';
      if (/^MONTH 0?[1-3]$/.test(text)) label.textContent = `${Number(text.split(' ')[1])}か月目`;
      else if (text.startsWith('BEFORE / ') || text.startsWith('AFTER / ')) label.textContent = text.split(' / ')[1];
      else if (/^(\d+ \/ [A-Z &-]+|QUESTIONS & ANSWERS|NETWORK ENGINEER TRAINING|OUR PRINCIPLE)$/.test(text)) label.remove();
    });
    doc.querySelectorAll('.system-topline .mono, .system-core .mono, .support-card-top .mono').forEach(label => label.remove());
    const diagram = introduction && !editorial ? doc.querySelector('.service-system') : null;
    const diagramHtml = diagram?.outerHTML || '';
    if (diagram) {
      diagram.remove();
      doc.querySelector('.cms-article-lead')?.remove();
    }
    return { html: doc.body.innerHTML, diagram: diagramHtml, editorial };
  }, [html, introduction]);
  if (article.editorial) return <DiagramMotion><div className="cms-service-article"><HtmlContent html={article.html} className="cms-service-body" /></div></DiagramMotion>;
  return <DiagramMotion><div className="cms-service-article">
    {visual ? <div className="service-photo-overview">{visual}{introduction}</div> : article.diagram ? <div className="service-overview">{introduction}<HtmlContent html={article.diagram} className="cms-service-body cms-overview-visual" /></div> : introduction}
    {visual && article.diagram && <details className="service-structure"><summary>構成と役割を図で見る<span aria-hidden="true">＋</span></summary><HtmlContent html={article.diagram} className="cms-service-body" /></details>}
    <HtmlContent html={article.html} className="cms-service-body" />
  </div></DiagramMotion>;
}
